angular.module('unergie.main')
.directive('userInfoAccountNominal', ($state, $uibModal, $filter, AlertManager, DataAccess, ApiUser, ModalService,
    AddrService, BoFeaturesService, AdminComments, MetaWatcher, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/account/userInfoAccountNominal.html',
        link($scope) {
            const feats = BoFeaturesService.getModuleFeatures('accountinfo')
            $scope.displayField = BoFeaturesService.fieldTester('accountinfo')
            $scope.mailDeliveryOk = true

            MetaWatcher.watch('DELIVERY_STATUS', 'userInfoAccountNominal', $scope, (status) => {
                $scope.mailDeliveryOk = status
            })

            // CONTACTS
            const mobilePhoneRegex = /^\+33[6-7]\d{8}$/
            const landlinePhoneRegex = /^\+33([1-59]\d{8}|80\d{7})$/
            const newPhoneTemplate = { value: '' }
            $scope.newPhonePayload = _.assign({}, newPhoneTemplate, { id_account: $scope.account.id })
            $scope.newPhoneFields = {
                value: {
                    required: true,
                    label: 'Numéro',
                    type: 'phone-international',
                },
            }
            const newMailTemplate = { value: '' }
            $scope.newMailPayload = _.assign({}, newMailTemplate, { id_account: $scope.account.id })
            $scope.newMailFields = {
                value: {
                    required: true,
                    label: 'Email',
                    type: 'email',
                },
            }

            $scope.isAIFeatureOn = (feature) => feats[feature]

            $scope.hasBillingAccount = () => $scope.account && $scope.account.billingaccount && Object.keys($scope.account.billingaccount).length > 0

            // CHANGE EMAIL
            $scope.onEmailChange = function (newMail, process) {
                if (process === false) {
                    return $scope.refreshAccount()
                }
            }

            // CONTACTS
            $scope.additionalPhones = () => _.filter($scope.account.contacts, (c) => (c.contact_type === 'mobilephone') || (c.contact_type === 'landline') || (c.contact_type === 'internationalphone'))

            $scope.deleteAdditionalPhone = (phone) =>
                DataAccess.deleteContact({ id: phone.id }).$promise.then((result) => {
                    AlertManager.success('Numéro supprimé.')
                    const comment = `<b>AUTOMATIQUE</b> : Numéro supprimé <b>${$filter('phone')(phone.value)}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    return $scope.refreshAccount() }).catch(ErrorCatcher)


            $scope.addAdditionalPhone = function () {
                if ($scope.newPhonePayload.value.match(mobilePhoneRegex) !== null) {
                    $scope.newPhonePayload.contact_type = 'mobilephone'
                } else if ($scope.newPhonePayload.value.match(landlinePhoneRegex) !== null) {
                    $scope.newPhonePayload.contact_type = 'landline'
                } else {
                    $scope.newPhonePayload.contact_type = 'internationalphone'
                }
                return DataAccess.addContact($scope.newPhonePayload).$promise.then((result) => {
                    AlertManager.success('Numéro ajouté.')
                    const comment = `<b>AUTOMATIQUE</b> : Numéro ajouté <b>${$filter('phone')($scope.newPhonePayload.value)}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    $scope.newPhonePayload = _.assign({}, newPhoneTemplate, { id_account: $scope.account.id })
                    return $scope.refreshAccount() }).catch(ErrorCatcher)
            }

            $scope.formatPhone33To06 = function (phone) {
                if (phone && (phone.indexOf('+33') === 0)) {
                    return `0${phone.slice(3)}`
                }
                return phone
            }

            $scope.additionalMails = () => _.filter($scope.account.contacts, (c) => c.contact_type === 'genericmail')

            $scope.deleteAdditionalMail = (mail) =>
                DataAccess.deleteContact({ id: mail.id }).$promise.then((result) => {
                    AlertManager.success('Email supprimé.')
                    const comment = `<b>AUTOMATIQUE</b> : Email supprimé <b>${mail.value}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    return $scope.refreshAccount() }).catch(ErrorCatcher)


            $scope.addAdditionalMail = function () {
                $scope.newMailPayload.contact_type = 'genericmail'
                return DataAccess.addContact($scope.newMailPayload).$promise.then((result) => {
                    AlertManager.success('Email ajouté.')
                    const comment = `<b>AUTOMATIQUE</b> : Email ajouté <b>${$scope.newMailPayload.value}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    $scope.newMailPayload = _.assign({}, newMailTemplate, { id_account: $scope.account.id })
                    return $scope.refreshAccount() }).catch(ErrorCatcher)
            }

            const formatAddress = function (a) {
                let addr = `${a.addr_num_street} `
                addr += `${a.addr_city_lbl} (`
                addr += `${a.addr_post_code})`
                if (a.addr_bat) {
                    addr += ` BAT : ${a.addr_bat}`
                }
                if (a.addr_details) {
                    addr += ` - ${a.addr_details}`
                }
                if (a.addr_locality) {
                    addr += ` - ${a.addr_locality}`
                }
                return addr
            }

            // CHANGE BILLING ADDRESS
            $scope.openBillingAddrModal = function () {
                $scope.account.billingaccount.id_account = $scope.account.id
                return AddrService.openAddrModal('billingAccount', $scope.account.billingaccount, (result) => {
                    if (result) {
                        let comment = '<b>AUTOMATIQUE</b> : Adresse de facturation modifiée :'
                        comment += `<br>Ancienne : <b>${formatAddress($scope.account.billingaccount)}</b>`
                        comment += `<br>Nouvelle : <b>${formatAddress(result)}</b>`
                        AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                        return $scope.refreshAccount()
                    }
                })
            }

            $scope.chgBirthDatePayload = { birth_date: $scope.account.birth_date }
            $scope.chgBirthDateFields = { birth_date: { label: 'Date de naissance', type: 'date', require: true } }
            $scope.chgBirthDate = function () {
                if (moment().diff($scope.chgBirthDatePayload.birth_date, 'years') > 100 || moment().diff($scope.chgBirthDatePayload.birth_date, 'years') < 1) {
                    AlertManager.error(`La date de naissance saisie n'est pas valide`)
                } else {
                    const payload = {
                        birth_date: moment($scope.chgBirthDatePayload.birth_date).toISOString(),
                    }
                    ApiUser.updateAccount({ id_account: $scope.account.id }, payload).$promise.then(() => {
                        AlertManager.success('Date de naissance modifiée')
                        $scope.account.birth_date = $scope.chgBirthDatePayload.birth_date
                    }).catch(ErrorCatcher)
                }
            }

            $scope.openSendinblueSubscriptionsModal = () => ModalService.openModal({ type: 'sendinblueSubscriptionsModal', size: 'lg' }, { id_account: $scope.account.id })


            $scope.getKrakenMigrationStatusLabel = function (account) {
                switch (account.kraken_migration_status) {
                    case null:
                        return 'Non commencée'
                    case 'SELECTED_FOR_MIGRATION':
                        return 'Migration demandée'
                    case 'VALIDATED':
                        return 'Données validées'
                    case 'CREATING':
                        return 'Création en cours'
                    case 'CREATED_IN_KRAKEN':
                        return 'Créé dans Kraken'
                    case 'PROCESSING':
                        return 'En cours de traitement'
                    case 'PROCESSED':
                        return 'Traité'
                    case 'POT_EXPORTED':
                        return 'Cagnotte exportée'
                    case 'SELECTED_FOR_BALANCE_EXPORT':
                        return 'Export de solde prévu'
                    case 'BALANCE_EXPORTED':
                        return 'Terminé'
                    case 'ERROR_VALIDATING':
                        return 'Erreur de validation'
                    case 'ERROR_CREATING_IN_KRAKEN':
                        return 'Erreur à la création dans Kraken'
                    case 'ERROR_PROCESSING':
                        return 'Erreur dans le traitement'
                    case 'ERROR':
                        return 'Erreur'
                    default:
                        return account.kraken_migration_status
                }
            }

            $scope.getKrakenMigrationStatusDescription = function (account) {
                switch (account.kraken_migration_status) {
                    case null:
                        return 'Le compte n\'a pas été marqué comme "à migrer"'
                    case 'SELECTED_FOR_MIGRATION':
                        return 'Le compte est sélectionné pour migration, il sera envoyé lors du prochain passage du batch'
                    case 'CREATED_IN_KRAKEN':
                        return 'Les données du contat ont été transmises à Kraken'
                    case 'VALIDATED':
                        return 'Les données du compte et ses contrats ont été validées'
                    case 'PROCESSING':
                        return 'Kraken est en train de traiter les données'
                    case 'PROCESSED':
                        return 'Kraken a bien traité les données'
                    case 'POT_EXPORTED':
                        return 'Cagnotte exportée vers Kraken'
                    case 'SELECTED_FOR_BALANCE_EXPORT':
                        return 'L\'export du solde est prévu'
                    case 'BALANCE_EXPORTED':
                        return 'Le solde a été transmis à Kraken'
                    case 'ERROR_VALIDATING':
                        return 'Les données ont été déclarées invalides par Kraken'
                    case 'ERROR_CREATING_IN_KRAKEN':
                        return 'La transmission des données à Kraken a échoué'
                    case 'ERROR_PROCESSING':
                        return 'Le traitement des données a échoué coté Kraken'
                    case 'ERROR':
                        return 'Erreur générique, en parler à la casquette'
                    default:
                        return account.kraken_migration_status
                }
            }
            $scope.canStartMigration = function(account) {
                return BoFeaturesService.isFeatureOn('canRunKrakenMigration') && account.kraken_migration_status === null
            }
            $scope.canReStartMigration = function(account) {
                return BoFeaturesService.isFeatureOn('canRunKrakenMigration') &&
                      (account.kraken_migration_status === 'ERROR_VALIDATING' ||
                      account.kraken_migration_status === 'ERROR_CREATING_IN_KRAKEN' ||
                      account.kraken_migration_status === 'ERROR_PROCESSING')
            }
            $scope.startMigration = function(account) {
                ApiUser.processKrakenMigration({ id_account: account.id, step: 'MARK' }, {}).$promise
                .then((result) => {
                    if (result.success) {
                        AlertManager.success('Demande de migration faite')
                    } else {
                        AlertManager.error('Erreur dans la demande')
                    }
                    account.kraken_migration_status = result.status
                }).catch(ErrorCatcher)
            }
            $scope.restartMigration = function(account) {
                ApiUser.processKrakenMigration({ id_account: account.id, step: 'MARK' }, { retry: true }).$promise
                .then((result) => {
                    if (result.success) {
                        AlertManager.success('Process de migration réinitialisé')
                    } else {
                        AlertManager.error('Erreur à la réinitialisation')
                    }
                    account.kraken_migration_status = result.status
                }).catch(ErrorCatcher)
            }
            $scope.retryMigration = function(account) {
                let step
                switch (account.kraken_migration_status) {
                    case 'ERROR_VALIDATING':
                        step = 'VALIDATE'
                        break
                    case 'ERROR_CREATING_IN_KRAKEN':
                        step = 'CREATE'
                        break
                    case 'ERROR_PROCESSING':
                        step = 'PROCESS'
                        break
                    default:
                        // nothing to do
                        return
                }
                ApiUser.processKrakenMigration({ id_account: account.id, step }, { retry: true }).$promise
                .then((result) => {
                    if (result.success) {
                        AlertManager.success('Nouvelle tentative fructueuse')
                    } else {
                        AlertManager.error('Erreur sur la nouvelle tentative')
                    }
                    account.kraken_migration_status = result.status
                }).catch(ErrorCatcher)

            }
        },
    })
)
